import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';

export const TableHeaderForProviderReview = [
  {
    headerName: 'Provider ID Type',
    field: 'providerIdTypeCd',
    editable: false,
    sortable: true,
    enableMenu: false,
    sortingOrder: ['desc', 'asc'],
    resizable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'ag-cell-action frr-overflow-visible',
  },
  {
    headerName: 'Provider ID',
    sort: 'asc',
    field: 'providerId',
    editable: false,
    sortable: true,
    enableMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    sortingOrder: ['desc', 'asc'],
    comparator: (valueA, valueB) => {
      return Number(valueA) - Number(valueB);
    },
    resizable: true,
    minWidth: Styles.Width_150,
    dataAlignRight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    cellClass: 'ag-cell-action frr-overflow-visible',
  },
  {
    headerName: 'Provider Name',
    field: 'name',
    editable: false,
    sortable: true,
    columnSpan: 3,
    minWidth: Styles.Width_200,
    cellRenderer: 'ProviderNameRender',
    cellClass: 'frr-ellipsis-text',

    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Freeze Date',
    field: 'reviewFreezeDt',
    cellRenderer: 'DrugNameRenderer',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_158,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      'white-space': 'normal',
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Completion Date',
    field: 'auditCompleteDt',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'NABP',
    field: 'nabpNum',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Claim Count',
    field: 'ccClaimCount',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    sortingOrder: ['desc', 'asc'],
    wrapHeaderText: true,
    autoHeaderHeight: true,
    dataAlignRight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
